import { useState } from "react";
import { useCurrentUserQuery } from "../../../../hooks/useCurrentUserQuery";
import { useToast } from "../../../../mantine/notifications/useToast";
import { DeleteConfirmationModal } from "../../../BuildingBlocks/Layout/Modals/DeleteConfirmationModal/DeleteConfirmationModal";
import { LoadOrError } from "../../../LoadOrError/LoadOrError";
import { useShouldShowStaffView } from "../../../StaffViewToggle/useShouldShowStaffView";
import "./Notes.scss";
import { useNotes } from "../../hooks/useNotes";
import { NotesEntry } from "./NotesEntry";
import { NotesList } from "./NotesList";

interface NotesProps {
  todoId: number;
}

function Notes({ todoId }: NotesProps) {
  const {
    notes,
    addNote,
    updateNote,
    deleteNote,
    isLoading: isNotesLoading
  } = useNotes({ todoId });

  const {
    currentUser,
    isLoading: isUserLoading,
    error
  } = useCurrentUserQuery();
  const { shouldShowStaffView } = useShouldShowStaffView();
  const { showErrorToast } = useToast();

  const [noteToDelete, setNoteToDelete] = useState<number | null>(null);
  const [deletingLoading, setDeleteLoading] = useState(false);

  function handleDeleteNote() {
    setDeleteLoading(true);

    if (!noteToDelete) {
      return;
    }

    deleteNote(noteToDelete)
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        setNoteToDelete(null);
        setDeleteLoading(false);
      });
  }

  const deleteNoteModalIsOpen = !!noteToDelete;

  return (
    <LoadOrError error={error} loading={isNotesLoading || isUserLoading}>
      {currentUser && notes && (
        <div className="Notes">
          <NotesEntry
            isStaffUser={shouldShowStaffView}
            submitButtonText="Erstellen"
            onSaveNote={addNote}
          />
          <NotesList
            isStaffUser={shouldShowStaffView}
            notes={notes}
            ownUserId={currentUser.id}
            onDeleteNote={setNoteToDelete}
            onUpdateNote={updateNote}
          />
          <DeleteConfirmationModal
            headerName="Notiz"
            isLoading={deletingLoading}
            name="diese Notiz"
            opened={deleteNoteModalIsOpen}
            toggleModal={() => setNoteToDelete(null)}
            onConfirm={handleDeleteNote}
          />
        </div>
      )}
    </LoadOrError>
  );
}

export { Notes, NotesProps };
